import React, { useEffect, useState, useRef, ReactNode, ChangeEvent } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Form from 'react-bootstrap/Form';
import { useForm, useFieldArray } from "react-hook-form";
import toast from 'react-hot-toast';
import moment from 'moment';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import { Alert } from 'react-bootstrap';

import "react-datepicker/dist/react-datepicker.css";
import { QBBalanceSheetPLListFormsI } from '../../../resources/form-props';
import { glClassificationApi } from '../../../resources/hooks/api/glClassificationApi';
import { thirdPartyApi } from '../../../resources/hooks/api/thirdPartyApiHook';
import { useCreditCardApi } from '../../../resources/hooks/api/creditCardApiHook';
import { QuickBookBSPLValidate } from '../../../resources/form-validator';
import { useChartAccountApi } from '../../../resources/hooks/api/chartAccountApiHook';
import { transTableDataApi } from '../../../resources/hooks/api/transApiHook';
import { getBranch } from '../../../store/user/selectors'
import { getThirdPartyStepsCompleted, getThirdPartyImportedStep } from '../../../store/settings/selectors'
import BeginningBalanceImportModal from '../../../components/Modal/BeginningBalanceImport/BeginningBalanceImportModal';

// import '../GlClassification/GlClassification.css'
import { GL_VP, MONTHS, SELECT_CUSTOM_STYLE, URLS } from '../../../resources/constants';
import SelectCustomOption from '../../../components/SelectCustomOption';
import { lastYears, calculateMaxHeightContent, usdCurrencyFormat } from '../../../resources/functions';
import Pagination from '@mui/material/Pagination';
import { useSettingsApi } from '../../../resources/hooks/api/useSettingsApiHook';
import { get } from 'lodash';

interface Props {

}

const QBBalanceSheetPLList: React.FC<Props> = () => {

    const { qbPostBSPL, qbFetchBSPL, quickBookImportData } = thirdPartyApi();
    const { createTransactionAdjustment } = transTableDataApi()
    const { fetchAccountSettingsData } = useSettingsApi();
    const quickBookStepCompleted = useSelector(getThirdPartyStepsCompleted);

    const navigate = useNavigate();
    const branchData = useSelector(getBranch)
    
    const { t } = useTranslation("scenes.thirdparty.quickbook.QBBalanceSheetPLList");

    const [records, setRecords] = useState<any>({
        data: [],
        total_records: 0,
    });
    const [searchParams, setSearchParams] = useState<any>({
        page: 1,
        per_page: 12
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [contentMaxHeight, setContentMaxHeight] = useState<number>(0)
    const [isOpenBBModal, setIsOpenBBModal] = useState<boolean>(false);
    const checkAllRef = useRef<HTMLInputElement>(null);
    const [selectedDateBB, setSelectedDateBB] = useState<Date[]>([]);
    const [totalRemovedRecord, setTotalRemovedRecord] = useState<number>(0);

    const { register, control, trigger, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm<QBBalanceSheetPLListFormsI>({
        defaultValues: {
            BS_PL: []
        },
        resolver: yupResolver(QuickBookBSPLValidate)
    });
    const { fields, append: formAppend, remove: formRemove } = useFieldArray({
        control,
        name: "BS_PL"
    });

    useEffect(() => {
        const recordField: any[] = [];
        records.data.forEach((record: any, index: number) => {
            if (fields.length > index) {
                recordField.push({
                    checked: getValues(`BS_PL.${index}.checked`),
                    formIndex: index,
                    field_id: record['id'],
                    month: record['month'],
                    year: record['year'],
                    status: record['status'],
                });
            } else {
                recordField.push({
                    checked: false,
                    formIndex: index,
                    field_id: record['id'],
                    month: record['month'],
                    year: record['year'],
                    status: record['status'],
                });
            }
        });

        reset({ BS_PL: recordField });
    }, [records.data])

    useEffect(() => {
        setContentMaxHeight(calculateMaxHeightContent(131));
    })

    useEffect(() => {
        if (fields.length == 0) {
            if (checkAllRef.current) {
                checkAllRef.current.checked = false;
            }
        }
        // if (fields.length == records.data.length) {
        //     if (checkAllRef.current) {
        //         checkAllRef.current.checked = true;
        //     }
        // }
    }, [fields])

    useEffect(() => {
        const interval = setInterval(() => {
            fetchTransactionList();
        }, 5000);
        return () => clearInterval(interval);
    }, [searchParams.page])


    const handleCheckAllChange = (e: any) => {
        if (checkAllRef.current) {
            checkAllRef.current.checked = e.target.checked;

            records.data.map((record: any, index: number) => {
                if (!(record['duplicate'] || record['posted'])) {
                    setValue(`BS_PL.${index}.checked`, e.target.checked)
                    // setValue(`BS_PL.${index}.checked`, getValues(`BS_PL.${index}.status`) == 2 ? e.target.checked : false)
                }
            })
        }
    };

    const fetchTransactionList = () => {
        const params: any = {
            branch_id: +branchData['id'],
            "page": searchParams['page'],
            "per_page": searchParams['per_page'],
        }

        // reset({
        //     BS_PL: []
        // })

        // setIsLoading(true);
        qbFetchBSPL(params, (message: string, resp: any) => {
            setRecords({
                data: resp.data.data.result,
                total_records: resp.data.data.total,
            });
            // setIsLoading(false);

            // if (resp.data.data.total == 0) {
            //     getSettingsData();
            // }

        }, (message: string, resp: any) => {
            // setIsLoading(false);
            toast.error(message);
        })
    }

    const handleCheckAll = (e: any, index: number) => {
        // setValue(`BS_PL.${index}.checked`, e.target.checked);

        let recordPos = index;
        if (e.target.checked) {
            do {
                setValue(`BS_PL.${recordPos}.checked`, true);
                recordPos = recordPos - 1;
            } while (recordPos >= 0);
        } else {
            while (recordPos <= records.data.length - 1) {
                setValue(`BS_PL.${recordPos}.checked`, false);
                recordPos = recordPos + 1;
            }
        }


        if (e.target.checked) {
            const checkedRecords = records.data.filter((record: any, index: number) => getValues(`BS_PL.${index}.checked`) === true);

            if (checkedRecords.length == records.data.length) {
                if (checkAllRef.current) {
                    checkAllRef.current.checked = true;
                }
            }
        } else {
            const uncheckedRecords = records.data.filter((record: any, index: number) => getValues(`BS_PL.${index}.checked`) === false);

            if (uncheckedRecords.length) {
                if (checkAllRef.current) {
                    checkAllRef.current.checked = false;
                }
            }
        }
    }

    const processData = (data: any) => {
        const removeRecords: number[] = [];
        const selectedRecords = data['BS_PL']
            .map((d: any, index: number) => {
                if (d['checked'] && d["status"] == 2) {
                    removeRecords.push(index);
                    return {
                        // id: d.id,
                        month: d.month,
                        year: d.year
                    };
                } else {
                    return null;
                }
            })
            .filter((e: any) => e); // Filter out null values
        if (selectedRecords.length > 0) {
            postData(selectedRecords, removeRecords);
        } else {
            toast.error(t("table.actions.submit"));
            return;
        }

    };
    const postData = (records: any, removeRecords: number[]) => {
        setIsLoading(true);
        qbPostBSPL({ records, branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setIsLoading(false);
            formRemove(removeRecords);
            setTotalRemovedRecord(totalRemovedRecord + removeRecords.length);
            toast.success(message)
            fetchTransactionList();
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const onChangePage = (event: any, page: number) => {
        reset({
            BS_PL: []
        })
        setSearchParams((prevState: any) => ({
            ...prevState,
            page: page
        }))
    }

    const getSettingsData = () => {
        setIsLoading(true)
        fetchAccountSettingsData({ branch_id: +branchData['id'] }, (msg: string, resp: any) => {
            setIsLoading(false)
            toast.success(t("table.noDataLeft"));
            navigate(URLS.DASHBOARD);
        }, (msg: string, resp: any) => {
            setIsLoading(false)
        })
    }

    const _handleQuickBookImportData = (step: number) => {
        if (!selectedDateBB.length) {
            setIsOpenBBModal(true);
            return;
        }

        const params: any = {};
        params['branch_id'] = +branchData['id'];
        params['step'] = step;

        params['bs_import_start_date'] = moment(selectedDateBB[0]).startOf('month').format('YYYY-MM-DD');
        params['bs_import_end_date'] = moment(selectedDateBB[1]).format('YYYY-MM-DD');

        setIsLoading(true)
        quickBookImportData(params, (message: string, resp: any) => {

            const d = localStorage.getItem("qbo_duration") || 0;
            localStorage.setItem("qbo_duration", moment(params['bs_import_end_date']).diff(moment(params['bs_import_start_date']), 'months') + 1 + (+d) + "");

            setIsLoading(false);
            setSelectedDateBB([])
            toast.success(message);
            fetchTransactionList();
        }, (message: string, resp: any) => {
            setIsLoading(false)
            setSelectedDateBB([])
            toast.error(message)
        })
    }

    const _handleBBDateSelection = () => {
        _handleQuickBookImportData(+quickBookStepCompleted + 1);
    }

    useEffect(() => {
        fetchTransactionList()
    }, [searchParams['page']])

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="page-title pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-12 align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">
                                {t("page.title")}
                            </h1>
                        </div>
                    </div>
                </div>

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className="filter-btn">
                            <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                                <div className="loader"></div>
                            </div>
                        </div>
                        <Form>
                            <div className='flex justify-content-end text-end'>
                                <button type="button" className="btn btn-cancel" onClick={() => setIsOpenBBModal(true)}>{t("buttons.importMore")}</button>
                                &nbsp;
                                {
                                    (fields.length > 0 && searchParams['page'] == 1) && (
                                        <button type="button" className="btn btn-primary" onClick={handleSubmit(processData)}>{t("buttons.verifyAndSubmit")}</button>
                                    ) || <></>
                                }
                            </div>


                            <br></br>
                            {/* <div className="table-responsive list-table table-scroll" style={{ maxHeight: contentMaxHeight }}> */}
                            {
                                localStorage.getItem("qbo_duration") && parseInt(localStorage.getItem("qbo_duration") || "0") > (records.total_records + totalRemovedRecord) && (
                                    <Alert variant={'info'}>
                                        <i className="fa fa-spinner fa-spin fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                                        {t("pending.download.message", { total_records: records.total_records + totalRemovedRecord, qbo_duration: localStorage.getItem("qbo_duration") || 0 })}
                                    </Alert>
                                ) || (
                                    <Alert variant={'info'}>
                                        <i className="fas fa-check-circle" aria-hidden="true"></i>&nbsp;&nbsp;
                                        {t("completed.download.message")}
                                    </Alert>
                                )
                            }
                            
                            <div className="table-responsive list-table table-scroll">
                                <table className="table table-default">
                                    <thead>
                                        <tr className="align-middle">
                                            <th className="w-5 text-start">
                                                <div className="form-check ">
                                                    <label >
                                                        {/* <input ref={checkAllRef} className="form-check-input wh-20 checkAll" type="checkbox" disabled={fields.length > 0 && fields[0].id ? true : false} onChange={handleCheckAllChange} /> */}
                                                        <input ref={checkAllRef} className="form-check-input wh-20 checkAll" type="checkbox" onChange={handleCheckAllChange} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th className="text-center w-5">{t("table.headers.month")}</th>
                                            <th className="text-center w-5">{t("table.headers.year")}</th>
                                            <th className="text-center w-5">{t("table.headers.status")}</th>
                                            <th className="text-center w-5">{t("table.headers.action")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            fields.length > 0 ?
                                                fields.map((data: any, index: any) => (
                                                    <tr className="align-middle" key={fields[index]['id']}>
                                                        <td className="text-start">
                                                            <div className="form-check ">
                                                                <label >
                                                                    <input className="form-check-input wh-20 checkbox" {...register(`BS_PL.${index}.checked`)}
                                                                        name={`BS_PL.${index}.checked`}
                                                                        defaultChecked={fields[index]['checked']}
                                                                        type="checkbox"
                                                                        disabled={fields[index]['status'] != 2}
                                                                        onChange={(e: any) => {
                                                                            handleCheckAll(e, index)
                                                                        }} />
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td className={"text-center"}>
                                                            <strong>{moment(fields[index].month, "MM").format('MMMM')}</strong>
                                                        </td>
                                                        <td className={"text-center"}>
                                                            <strong>{fields[index].year}</strong>
                                                        </td>
                                                        <td className={"text-center"}>
                                                            <strong>{fields[index].status == 1 ? 'Pending' : "Completed"}</strong>
                                                        </td>
                                                        <td className={"text-end"}>
                                                            {
                                                                fields[index].status == 2 ? (
                                                                    <>
                                                                        <button type='button' className='btn btn-warning btn-sm' onClick={() => navigate('/quickbook-bs/' + fields[index].month + '/' + fields[index].year)}>{t("table.actions.viewBS")}</button>&nbsp;
                                                                        <button type='button' className='btn btn btn-success btn-sm' onClick={() => navigate('/quickbook-pl/' + fields[index].month + '/' + fields[index].year)}>{t("table.actions.viewPL")}</button>
                                                                    </>
                                                                ) : (<></>)
                                                            }

                                                        </td>
                                                    </tr>
                                                )) : <tr>
                                                    <td colSpan={5} className='text-center'>{t("table.noData")}</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </Form>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <Pagination count={Math.ceil(records['total_records'] / searchParams['per_page'])} showFirstButton showLastButton onChange={onChangePage} />
                    </div>

                </div>
            </div>

            {
                isOpenBBModal &&
                <BeginningBalanceImportModal step={+quickBookStepCompleted + 1} selectDate={setSelectedDateBB} handleBBDateSelection={_handleBBDateSelection} closeModal={() => setIsOpenBBModal(false)} />
            }
        </div>

    )
}

export default QBBalanceSheetPLList;